import React from 'react';

const FeeHelp = () => {
	return <>Help</>;
};

export default FeeHelp;
